<template>
    <Carousel :products="products" />
</template>
<script>
import Carousel from './CarouselComponent.vue';

export default {
    components: {
        Carousel
    },
    data() {
        return {
            products: []
        }
    },
    async mounted() {
        try {
            const consumerKey = 'ck_5ea694b3aa5bc58e9aa9a9d91c1018756b6141fb';
            const consumerSecret = 'cs_4dd259442edbc7e72a18dd8580110029a0b085c4';
            const response = await this.$axios.get("/wc/v3/products", {
                auth: {
                    username: consumerKey,
                    password: consumerSecret,
                },
            });

            this.products = response.data;
        } catch (error) {
            console.error(error);
        }
    }
}
</script>